export const home = {
  'seo.title': 'Sofia og Elena — Ernæring og Kosmetologi | Dobbel Ekspertise',
  'seo.description': 'Felles arbeid av to ekspert ernæringsfysiologer på skjæringspunktet mellom ernæring og kosmetologi.',
  'seo.keywords': 'ernæringsfysiolog, kosmetolog, helse, hormoner, mage-tarm, metabolisme, barneernæring, Sofia, Elena',

  'hero.title': 'Et system der kroppen din\nendelig høres vakker ut',
  'hero.subtitle': 'Felles arbeid av to eksperter på skjæringspunktet mellom ernæring og kosmetologi.\nVi behandler ikke symptomer — vi gjenoppbygger helsen din "murstein for murstein".',
  'hero.cta': 'Start din reise',
  'hero.imageAlt': 'Sofia og Elena — eksperter innen ernæring og kosmetologi',
  'hero.ctaAria': 'Start reisen til helse',

  'whyTwo.title': 'Hvorfor to eksperter = ditt resultat ×10',
  'whyTwo.description': 'Mens en ekspert gjenoppretter din hormonelle balanse og mage-tarm funksjon, bygger den andre opp metabolismen din, arbeider med mangler og sørger for at huden din stråler.',
  'whyTwo.quote': 'Du får dobbel kontroll og dyp ekspertise fra to sider samtidig.',
  'whyTwo.imageAlt': 'Profesjonell ernæringskonsultasjon',
  'whyTwo.experts': 'Eksperter',
  'whyTwo.result': 'Resultat',

  'philosophy.title': 'Kaos i hodet = kaos i kroppen',
  'philosophy.belief': 'Vi tror ikke på dietter. Vi tror på kunnskap.',
  'philosophy.description': 'Vi lærer deg å forstå kroppens signaler, slik at du om 2 måneder blir din egen beste ernæringsfysiolog.',

  'cta.title': 'Klar til å slutte å prøve\nog begynne å få resultater?',
  'cta.primary': 'Velg program',
  'cta.secondary': 'Gratis diagnostikk',
  'cta.primaryAria': 'Velg et ernæringsprogram',
  'cta.secondaryAria': 'Bestill gratis diagnostikk',
};